import { el } from '../ui/dom';
import type { CmsLoginMethod } from './client';

export interface LoginMethodControl {
  readonly element: HTMLElement;
  readonly value: () => CmsLoginMethod;
  readonly onChange: (listener: (method: CmsLoginMethod) => void) => void;
}

/** Password-only control; legacy stored provider metadata is never an option. */
export function createLoginMethodControl(_options: {
  readonly current: CmsLoginMethod;
  readonly allowEmailPassword?: boolean;
  readonly label?: string;
}): LoginMethodControl {
  return {
    element: el('div', { class: 'cms-auth-method-field' },
      el('input', { attrs: { type: 'hidden', name: 'loginMethod', value: 'email_password' } }),
      el('strong', { text: 'Email & password' })),
    value: () => 'email_password',
    onChange: () => {},
  };
}
